import { ClientContactPerson } from "./client-contact-person.model";
import { ClientMapper } from "../client.mapper";

export class ClientContactPersonMapper {
  public static map(data: any): ClientContactPerson {
    if (!data) {
      return null;
    }

    return new ClientContactPerson(
      data.id,
      data.client ? ClientMapper.map(data.client) : null,
      data.name,
      data.email,
      data.phone,
      data.isActive,
    );
  }
}
